module.exports = __webpack_public_path__ + "img/10.6d798f21.jpg";